import React from "react";
import { Link } from "react-router-dom";

export default function PageHero({ eyebrow, title, subtitle, image, children }) {
    return (
        <section data-testid="page-hero" className="relative min-h-[55vh] flex items-center overflow-hidden">
            {image && (
                <>
                    <div
                        className="absolute inset-0 bg-cover bg-center"
                        style={{ backgroundImage: `url(${image})` }}
                        aria-hidden
                    />
                    <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black" aria-hidden />
                </>
            )}
            {!image && <div className="absolute inset-0 bg-radial-gold" aria-hidden />}
            <div className="absolute inset-0 bg-grid opacity-30" aria-hidden />

            <div className="relative max-w-5xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-24 md:py-32">
                {eyebrow && (
                    <span className="inline-block text-[10px] tracking-[0.3em] uppercase text-gold mb-5 border border-gold/30 rounded-full px-4 py-1.5">
                        {eyebrow}
                    </span>
                )}
                <h1 className="font-display font-bold text-4xl sm:text-5xl md:text-6xl text-white text-balance leading-[1.05] max-w-3xl">
                    {title}
                </h1>
                {subtitle && (
                    <p className="mt-5 text-white/70 text-base md:text-lg max-w-2xl leading-relaxed">{subtitle}</p>
                )}
                {children && <div className="mt-8">{children}</div>}
            </div>
        </section>
    );
}

export function HeroCTAs() {
    return (
        <div className="flex flex-col sm:flex-row gap-3">
            <Link
                to="/contact"
                data-testid="hero-book-demo-btn"
                className="inline-flex items-center justify-center bg-gold text-black font-semibold text-sm px-7 py-3.5 rounded-full hover:scale-[1.03] hover:bg-gold-hover transition-all duration-300 gold-glow"
            >
                Book Free Trial Class
            </Link>
            <Link
                to="/courses"
                data-testid="hero-courses-btn"
                className="inline-flex items-center justify-center border border-white/25 text-white font-semibold text-sm px-7 py-3.5 rounded-full hover:bg-white/5 transition-colors"
            >
                Explore Courses
            </Link>
        </div>
    );
}
